<!--
 * @Author: your name
 * @Date: 2021-07-07 14:40:32
 * @LastEditTime: 2021-10-14 23:17:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\spike\Detail.vue
-->
<template>
  <div class="content1">
    <div class="header">
      商品信息
    </div>
    <div class="spike-content">
      <el-form>
        <el-form-item label="商品名称：">
          <el-button type="primary"
                     v-if="spikeInfo === null"
                     @click="onShowProduct">选择商品</el-button>
          <span v-if="spikeInfo">{{spikeInfo.product_name}}</span>
        </el-form-item>
        <el-form-item v-if="spikeInfo"
                      label="拼团时间：">
          <el-col :span="4">
            <el-date-picker v-model="spikeInfo.date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间" />
          </el-col>
        </el-form-item>
        <el-form-item label="成团人数："
                      v-if="spikeInfo">
          <el-col :span="4">
            <el-input v-model="spikeInfo.join_count">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-table v-if="spikeInfo"
                :data="spikeInfo.sku_list"
                style="width: 100%">
        <el-table-column prop="attribute_name_one"
                         label="属性一"
                         width="width">
          <template slot-scope="scope">
            {{scope.row.spec_name_one ? scope.row.spec_name_one  + ':'+ scope.row.attribute_name_one : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="attribute_name_two"
                         label="属性二"
                         width="width">
          <template slot-scope="scope">
            {{scope.row.spec_name_two ? scope.row.spec_name_two  + ':'+ scope.row.attribute_name_two : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="normal_price"
                         label="原价"
                         width="width">
        </el-table-column>
        <el-table-column prop="price"
                         label="拼团价"
                         width="width">
          <template slot-scope="scope">
            <el-input v-model="scope.row.price"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="space">
        <div>阶梯返还</div>
        <el-button type="primary"
                   @click="onShowStep">新增返回阶梯</el-button>
      </div>
      <el-table v-if="spikeInfo"
                :data="spikeInfo.steps"
                style="width: 100%">
        <el-table-column prop="name"
                         label="名称">
        </el-table-column>
        <el-table-column prop="count"
                         label="拼团人数">
        </el-table-column>
        <el-table-column prop="amount"
                         label="返还金额">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="edit"
                  @click="onDelStep(scope.$index)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fix-confirm">
      <el-button class="tb-button"
                 @click="cancel">取消</el-button>
      <el-button class="tb-button"
                 type="primary"
                 @click="submit">发布</el-button>
    </div>
    <el-dialog title="新增阶梯返回"
               :visible.sync="stepDialog"
               width="30%">
      <el-form label-width="100px">
        <el-form-item label="名称："
                      width="40%">
          <el-input v-model="selStep.name"></el-input>
        </el-form-item>
        <el-form-item label="拼团人数：">
          <el-input v-model="selStep.count"
                    type="number"></el-input>
        </el-form-item>
        <el-form-item label="返还金额：">
          <el-input v-model="selStep.amount"
                    type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="stepDialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="onAddStep">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择商品"
               width="50vw"
               :visible.sync="productDialog">
      <div class="product-search flex">
        <span>搜索商品：</span>
        <el-input v-model="productname"
                  style="width: 216px;"
                  @change="searchGoods"></el-input>
      </div>
      <el-table ref="multipleTable"
                :data="productData"
                class="tb-table"
                height="48vh"
                highlight-current-row
                @current-change="handleCurrentChange">
        <el-table-column type="index"
                         width="80" />
        <el-table-column prop="product_id"
                         label="商品id"
                         width="100" />
        <el-table-column prop="product_name"
                         label="商品名称" />
      </el-table>
      <el-pagination background
                     class="tb-pagination"
                     layout="prev, pager, next"
                     :current-page="page.no + 1"
                     :page-size="page.size"
                     :total="page.total"
                     @current-change="pageChange" />
      <span slot="footer">
        <el-button @click="productDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      productDialog: false,
      stepDialog: false,
      productname: '',
      productData: [],
      productChoose: [],
      page: {
        no: 0,
        size: 10,
        total: 0
      },
      id: null,
      spikeInfo: null,
      selStep: {}
    }
  },
  mounted () {
    this.id = this.$route.query.id
    if (this.id) {
      this.getDetail()
    }
  },
  computed: {
  },
  methods: {
    async getDetail () {
      const params = { id: this.id }
      const url = 'admin/groupbargain/detail'
      const detail = await this.$https.get(url, { params })
      if (!detail) return
      detail.product_id = detail.id
      detail.id = null
      detail.date = []
      let skuList = detail.sku_list
      skuList.forEach(element => {
        element.price = element.price / 100
        element.normal_price = element.normal_price / 100
      });
      let steps = detail.steps
      steps.forEach(step => {
        step.amount = step.amount / 100
      })
      detail.date = [detail.start_time, detail.end_time]
      detail.sku_list = skuList
      detail.steps = steps
      this.spikeInfo = detail
    },
    cancel () {
      this.$router.back()
    },
    submit () {
      if (null === this.spikeInfo) {
        this.$message.error('请选择商品')
        return
      }
      if (this.spikeInfo.date.length === 0) {
        this.$message.error('请选择拼团时间')
        return
      }
      if (!this.spikeInfo.join_count) {
        this.$message.error('请输入成团人数')
        return
      }
      const skuList = JSON.parse(JSON.stringify(this.spikeInfo.sku_list))
      skuList.forEach(item => {
        item.price = item.price * 100
      })
      const steps = JSON.parse(JSON.stringify(this.spikeInfo.steps))
      steps.forEach(step => {
        step.amount = step.amount * 100
      })
      const params = {
        join_count: this.spikeInfo.join_count,
        product_id: this.spikeInfo.product_id,
        sku_list: skuList,
        steps: steps,
        start_time: this.spikeInfo.date[0],
        end_time: this.spikeInfo.date[1],
      }
      if (this.id) {
        params.id = this.id
      }
      const url = 'admin/groupbargain/edit'
      this.$https.post(url, params).then(res => {
        if (!res) return
        this.$router.back()
      })
    },
    onShowProduct () {
      this.productDialog = true
    },
    onShowStep () {
      this.stepDialog = true
      this.selStep = { name: '', count: '', amount: '' }
    },
    onAddStep () {
      if (!this.selStep.name) {
        this.$message.error('请输入名称')
        return
      }
      if (!this.selStep.count) {
        this.$message.error('请输入团购人数')
        return
      }
      if (!this.selStep.amount) {
        this.$message.error('请输入返还金额')
        return
      }
      this.spikeInfo.steps.push(this.selStep)
      this.stepDialog = false
    },
    onDelStep (index) {
      this.$confirm('是否删除此阶梯吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.detail.steps.splice(index, 1)
      }).catch(() => { })
      this.spikeInfo.steps.splice(index, 1)
    },
    getProduct () {
      const { no, size } = this.page
      const params = {
        page_no: no,
        page_size: size,
        name: this.productname
      }
      const url = 'admin/theme/product/add/list'
      this.$https.get(url, { params }).then(res => {
        if (!res) return
        this.page.total = res.total_count
        this.productData = res.list
      })
    },
    searchGoods () {
      this.page.no = 0
      this.getProduct()
    },
    async handleCurrentChange (val) {
      this.$confirm('是否选定商品?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.productChoose = [val]
        const params = { id: this.productChoose[0].product_id }
        const url = 'admin/product/detail'
        const detail = await this.$https.get(url, { params })
        if (!detail) return
        detail.product_id = detail.id
        detail.id = null
        detail.date = []
        let skuList = detail.sku_list
        skuList.forEach(element => {
          element.price = element.price / 100
          element.normal_price = element.price
        });
        detail.steps = []
        detail.sku_list = skuList
        this.spikeInfo = detail
        this.productDialog = false
      }).catch(() => {
      })
    },
    pageChange (no) {
      this.page.no = no - 1
      this.getProduct()
    },
  }

}
</script>

<style lang="scss" scoped>
.content1 {
  margin: 32px;
  padding-bottom: 68px;
  background: white;
  .header {
    padding: 24px;
    border-bottom: 1px solid #e9e9e9;
  }
  .space {
    padding: 24px 0;
    font-size: 500;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
  }
  .spike-content {
    padding: 24px;
  }
}
</style>
